import type { Resource } from "i18next";
import { generatedTranslationResources } from "../../assets/locales/generated/resources";

export const i18nResources: Resource = generatedTranslationResources;
